/* eslint-disable import/no-unresolved */
import React from "react"
import styled from "styled-components"
import tw from "twin.macro"

import { Connector1, Connector2 } from "@components/icons"
import { ButtonSecondary } from "@templates"
import { colors } from "@config"

const MultipleTree = styled.div`
  ${tw`flex flex-col md:flex-row md:gap-10 ml-4 md:ml-0`}
`

const Tree = styled.div`
  ${tw`p-0 flex`}
  & {
    svg {
      ${tw`hidden md:block md:mt-1 flex-shrink-0`}
    }
    ul {
      ${tw`list-disc md:list-none p-0 self-start m-0 ml-2`}
      &.list-2 {
        ${tw`md:-ml-4`}
      }
      li {
        ${tw`mb-6`}

        &.branch {
          ${tw`mb-5 ml-0 md:mb-6 md:ml-4`}
        }

        &.last-stand {
          ${tw`ml-0 mt-0 md:mt-7 md:ml-8`}
          a {
            ${tw`w-full`}
          }
        }
      }
    }
  }
`

const SkillTree = () => (
  <MultipleTree>
    <Tree>
      <Connector1 />
      <ul>
        <li>Mathematics</li>
        <li>Python</li>
        <li className="branch">FastAPI, Django</li>
        <li className="branch">AI/LLM</li>
        <li>JavaScript/TypeScript</li>
        <li className="branch">Next.js, Node.js</li>
      </ul>
    </Tree>
    <Tree>
      <Connector2 />
      <ul className="list-2">
        <li>Unity 3D (C#), Babylon.js</li>
        <li>C++</li>
        <li>Web3, Metamask</li>
        <li>Adobe CC & Figma</li>
        <li className="last-stand">
          <ButtonSecondary color={colors.amaranth}>
            <a
              href="/resume.pdf"
              target="_blank"
              data-type="url"
              className="btn__text"
              rel="noopener noreferrer"
            >
              <span>Resume</span>
            </a>
          </ButtonSecondary>
        </li>
      </ul>
    </Tree>
  </MultipleTree>
)

export default SkillTree
